import React, { useContext } from "react"
import { observer } from "mobx-react"
import { IconCircleCheck } from "@tabler/icons-react"
import { AppWorkspaceContext } from "../../stores/AppWorkspace"
import { PLATFORMS_INDEX, testedLabel } from "../../../docs/catalog"
import type { TestedRun } from "../../../docs/types"

// The Tested badge (contract v8): "Tested live · Oct 7, 2026 · 0.4.19", built
// from a framework or platform row's `tested` and linked to the "How we test
// platforms" guide. It is a claim that three agent trials passed, so it renders
// nothing at all without a `tested` value — never a placeholder, never a
// "Tested" without the run behind it.
export const TestedBadge: React.FC<{ tested: TestedRun | null | undefined; className?: string }> = observer(
  ({ tested, className }) => {
    const workspace = useContext(AppWorkspaceContext)
    const label = testedLabel(tested)
    if (!label) return null
    const href = PLATFORMS_INDEX?.methodGuidePath ?? null
    const classes = ["or-tested-badge", className].filter(Boolean).join(" ")
    const body = (
      <>
        <IconCircleCheck size={15} aria-hidden="true" />
        <span>{label}</span>
      </>
    )
    if (!href) return <span className={classes}>{body}</span>
    return (
      <a
        className={classes}
        href={href}
        title="How we test: an AI agent adds OpenReceive and the result passes a live deploy"
        onClick={(event) => {
          event.preventDefault()
          workspace.openHref(href)
        }}
      >
        {body}
      </a>
    )
  }
)
